import useQueryApiClient from 'utils/useQueryApiClient';
import { NewPasswordForm } from 'ui/Form/auth/NewPasswordForm';
import { notification } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { LoginStyleContainer } from './LoginStyleContainer';
import PublicRoute from 'enums/publicRoutes';

export const NewPassword = () => {
  const [notificationApi, contextHolder] = notification.useNotification();
  const navigate = useNavigate();
  const intl = useIntl();
  const { appendData } = useQueryApiClient({
    request: {
      url: `api/v2/new-password-reset`,
      method: 'POST',
    },
    onSuccess: (response) => {
      openNotification(response.message);
      setTimeout(() => {
        navigate(PublicRoute.HOME);
      }, 5000);
    },
    onError: (error) => {
      openNotification(
        error.message ??
          error.error ??
          intl.formatMessage({ id: 'message.undefined' })
      );
    },
  });

  const openNotification = (message: string) => {
    notificationApi['info']({
      message: message,
      showProgress: true,
      pauseOnHover: true,
      duration: 5,
    });
  };

  return (
    <LoginStyleContainer>
      {contextHolder}
      <NewPasswordForm appendData={appendData} />
    </LoginStyleContainer>
  );
};
